import React, { createContext, useContext, ReactNode } from 'react';
import { useExportNotifications, UseExportNotificationsReturn } from 'hooks/useExportNotifications';

const ExportNotificationContext = createContext<UseExportNotificationsReturn | undefined>(undefined);

interface ExportNotificationProviderProps {
  children: ReactNode;
}

/**
 * Provider component that wraps the app and provides shared export notification state
 * This ensures both NotificationPanel and ExportManagement use the same data source
 */
export const ExportNotificationProvider: React.FC<ExportNotificationProviderProps> = ({ children }) => {
  const exportNotifications = useExportNotifications();

  return (
    <ExportNotificationContext.Provider value={exportNotifications}>{children}</ExportNotificationContext.Provider>
  );
};

/**
 * Hook to access shared export notification context
 * Must be used within ExportNotificationProvider
 */
export const useExportNotificationContext = (): UseExportNotificationsReturn => {
  const context = useContext(ExportNotificationContext);

  if (context === undefined) {
    throw new Error('useExportNotificationContext must be used within ExportNotificationProvider');
  }

  return context;
};
